<template>
  <div class="barSetCon">
    <h4 style="margin:0 0 10px 0;">
      网吧名称：{{ barName }}
      <b style="margin-left:30px;">通行证账号：{{ passportName }}</b>
    </h4>
    <ButtonGroup type="button" v-model="type">
      <Button
        @click="changeState"
        :type="type == 0 ? 'primary' : 'default'"
        label="1"
        >调试模式设置
      </Button>
      <Button
        @click="gotoFn()"
        :type="type == 1 ? 'primary' : 'default'"
        label="2"
        >日志管理</Button
      >
    </ButtonGroup>
    <debugModelCom
      @changeFn="changeFn"
      :data="cfgData"
      :barId="barId"
      :ruleList="ruleList"
      :debugRule="debugRule"
      v-show="!type"
    />
    <!-- <recordCom
      v-show="type"
      ref="rocordCom"
      :data="cfgData"
      :barId="barId"
      :type="type"
    /> -->
  </div>
</template>
<script>
import debugModelCom from './setModel'
import recordCom from './record'
import {
  getDebugCfgByBarId,
  getRuleByBarId,
  searchBarList,
} from '@/requests/debug'
export default {
  props: ['data'],
  components: {
    debugModelCom,
    recordCom,
  },
  data() {
    return {
      type: 0,
      cfgData: '',
      barId: '',
      ruleList: [],
      debugRule: [],
      barName: '',
      passportName: '',
    }
  },
  watch: {
    type() {
      this.init()
    },
  },
  mounted() {
    this.init()
    this.barId = this.data
  },
  methods: {
    gotoFn() {
      console.log(this.cfgData)
      if (
        JSON.parse(this.cfgData) == undefined ||
        JSON.parse(this.cfgData) == null ||
        JSON.parse(this.cfgData) == '' ||
        JSON.parse(this.cfgData).flag == 0 ||
        JSON.parse(this.cfgData).ip == ''
      ) {
        window.$Message.show({
          title: '提示',
          type: 'info',
          msg: '请设置调试模式开关或调试终端IP',
        })
      } else {
        window.open(
          `/v2/log?barID=${this.barId}&id=${this.cfgData}`,
          'newwindow',
          'height=800,width=1200,top=0,left=0'
        )
      }
    },
    changeState() {
      this.type = 0
      //this.$refs.rocordCom.closeFn()
    },
    async searchBarList() {
      let res = await searchBarList(1, 30, this.data)

      if (res.code == 200) {
        this.barName = res.data.records[0].barName
        this.passportName = res.data.records[0].passportName
      }
    },
    changeFn() {
      this.init()
    },
    init() {
      this.ruleList = []
      this.debugRule = []
      this.getDebugCfgByBarId()
      this.getRuleByBarId()
      this.searchBarList()
    },
    async getDebugCfgByBarId() {
      let res = await getDebugCfgByBarId(this.data)
      if (res.code == 200) {
        this.cfgData = res.data
      }
      console.log(this.cfgData)
    },
    async getRuleByBarId() {
      let res = await getRuleByBarId(this.data)
      if (res.code == 200) {
        if (res.data != null && res.data != '') {
          let obj = JSON.parse(res.data)
          let index = obj.filter((item) => item.ruleId == 1000000000)
          if (index != '') {
            this.debugRule = index
          }
          // obj.forEach((element) => {
          //   console.log(element.debugIp)
          //   if (element.debugIp == undefined) {
          //     element.debugIp = ''
          //   }
          // })
          this.ruleList = obj.filter((item) => item.ruleId != 1000000000)
        } else {
          this.debugRule = []
          this.ruleList = []
        }
      }
    },
  },
}
</script>
